<template>
    <div class="row">
          <div class="col-12 mb-1">
            <label class="form-label">Maaş Tipi</label>
            <v-select-list :options="salaryTypesOfSgk" label="value" v-model="salaryTypeCode" placeholder="Maaş Tipi"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-select-list :options="branches" v-on:input="getGarages(true)" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Garaj</label>
            <v-select-list :options="garages" label="GarageName" :disabled="branch == null || (garages || []).length == 0" v-model="garage" placeholder="Tüm Garajlar"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Maaş</label>
            <v-currency-input  input-class="text-right" :value="value.Salary" v-on:update-value="currencyAmount => value.Salary = currencyAmount"></v-currency-input>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ücret Nevi</label>
            <v-select-list :options="types" placeholder="Ücret Nevi" v-model="type" label="Name"></v-select-list>
        </div>
        <div class="col-12 mb-1" v-if="this.value.SGK==false">
            <label class="form-label">Son Geçerlilik Tarihi</label>
            <v-date-picker placeholder="Son Geçerlilik Tarihi(-e kadar)" v-model="value.Date" label="Date"></v-date-picker>
        </div>
         <div class="col-12 mb-1" v-else-if="this.value.SGK==true">
             <label class="form-label">Dönem(-den itibaren)</label>
            <v-date-picker placeholder="Dönem(-den itibaren)" type="month" v-model="period" label="Date"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.ASGARI_UCRETLI">Asgari Ücretli</b-form-checkbox>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.NETTEN_GIT">Netten Git</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import CompanyApi from '@/api/company'
import { BFormCheckbox } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
import moment from 'moment'

export default {
    components:{
        VCurrencyInput,
        BFormCheckbox
    },
    props:{
        value:Object
    },
    data(){
        return {
            garages:[],
            branches:[],
            test:null,
            salaryTypesOfSgk:[
                {key:true,value:"SGK"},
                {key:false,value:"Organizasyonel"}
            ],
            types:[]
        }
    },
    mounted(){
        this.getBranches(false)
        this.getGarages()
        this.getSalaryTypes()
    },
    methods:{
        getBranches(bool){
            CompanyApi.Branch.ListByCode('O').then(res=>{
                if(bool) {
                    this.value.VehicleInventoryGarageId = null
                    this.garages = []
                }
                this.branches = res.data.Data
            })
        },
        getGarages(){
            if(this.value?.BranchId){
                VehicleOperationsApi.Garage.ListByBranch(this.value?.BranchId).then(res=>{
                    this.garages = res.data.Data
                })
            }
        },
        getSalaryTypes(){
            SystemDataApi.SalaryType().then(res=>{
                this.types = Object.entries(res.data).map(([key,value])=>({
                    Id:key,
                    Name:value
                }))
            })
        }
    },
    computed:{
        branch:{
            get:function(){
                return this.branches.find(s=>s.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
        garage:{
            get:function(){
                return this.garages.find(s=>s.Id==this.value.VehicleInventoryGarageId)
            },
            set:function(value){
                this.value.VehicleInventoryGarageId = value?.Id || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.UCRET_NEVI)
            },
            set:function(value){
                this.value.UCRET_NEVI = value?.Id || null
            }
        },
        salaryTypeCode:{
            get:function(){
                return this.salaryTypesOfSgk.find(b=>b.key==this.value.SGK)
            },
            set:function(value){
                this.value.SGK = value['key']
            }
        },
        period:{
            get:function(){
                return `${this.value.Year}-${this.value.Month > 9 ? this.value.Month : `0${this.value.Month}`}`
            },
            set:function(value){
                try {
                    const date = value?.split('-')
                    const year = Number(date?.[0])
                    const month = Number(date?.[1])
                    this.value.Month = month
                    this.value.Year = year
                } catch (error) {
                    this.value.Month = null
                    this.value.Year = null
                }
            }
        }
    }
}
</script>